import { ResgateParcialService } from '@services';
import { currency } from '@utils';
import { format, isBefore } from 'date-fns';

export const gerarDadosSimulacao = (
  dadosSimulacao,
  dadosPrevidenciarios,
  dadosPessoais,
  dadosEmprestimo
) => {
  const dataLimite = new Date(2018, 3, 30);
  const percentualMaximo =
    isBefore(new Date(dadosPrevidenciarios.DataInscricao), dataLimite) &&
    dadosPessoais.plano !== '2'
      ? 45
      : 30;
  const percentualRetirado =
    (dadosSimulacao.ValorTotalResgate / dadosSimulacao.ValorIntegral) * 100;
  const percentualRestante = Math.max(percentualMaximo - percentualRetirado, 0);

  // Regressivo
  const valorTotalRegressivo =
    dadosSimulacao.ValorTotalResgate -
    (dadosSimulacao.ValorTotalResgate *
      dadosSimulacao.AliquotaValorTotalRegressivo) /
      100;

  const descontoTotalRegressivo = Math.min(
    valorTotalRegressivo,
    dadosEmprestimo.SaldoVencido +
      dadosEmprestimo.SaldoVencer * (percentualRetirado / 100) || 0
  );
  const saldoVencidoRegressivo = Math.min(
    valorTotalRegressivo,
    dadosEmprestimo.SaldoVencido
  );

  const SaldoVencerRegressivo = Math.min(
    valorTotalRegressivo - saldoVencidoRegressivo,
    dadosEmprestimo.SaldoVencer * (percentualRetirado / 100)
  );

  const descontoEmprestimoRegressivo = {
    descontoTotal: descontoTotalRegressivo,
    saldoVencido: saldoVencidoRegressivo,
    saldoVencer: SaldoVencerRegressivo,
  };

  // Progressivo
  const valorTotalProgressivo =
    dadosSimulacao.ValorTotalResgate -
    (dadosSimulacao.ValorTotalResgate * 15) / 100;

  const descontoTotalProgressivo = Math.min(
    valorTotalProgressivo,
    dadosEmprestimo.SaldoVencido +
      dadosEmprestimo.SaldoVencer * (percentualRetirado / 100) || 0
  );
  const saldoVencidoProgressivo = Math.min(
    valorTotalProgressivo,
    dadosEmprestimo.SaldoVencido
  );

  const SaldoVencerProgressivo = Math.min(
    valorTotalProgressivo - saldoVencidoProgressivo,
    dadosEmprestimo.SaldoVencer * (percentualRetirado / 100)
  );

  const descontoEmprestimoProgressivo = {
    descontoTotal: descontoTotalProgressivo,
    saldoVencido: saldoVencidoProgressivo,
    saldoVencer: SaldoVencerProgressivo,
  };

  return {
    ...dadosSimulacao,
    percentualRetirado,
    percentualRestante,
    valorTotalResgateRegressivo:
      valorTotalRegressivo - descontoEmprestimoRegressivo.descontoTotal,
    descontoEmprestimoRegressivo,
    valorTotalResgateProgressivo:
      valorTotalProgressivo - descontoEmprestimoProgressivo.descontoTotal,
    descontoEmprestimoProgressivo,
  };
};

export const dadosSimulacaoResgatePDF = (
  infosData,
  dadosEmprestimo,
  dadosPrevidenciarios
) => {
  return {
    dataReferenciaEmprestimo: format(
      new Date(dadosEmprestimo.DataReferencia),
      'MM/yyyy'
    ),
    percentualRetirado: `${infosData.result.percentualRetirado?.toFixed(2)}%`,
    percentualRestante: `${infosData.result.percentualRestante?.toFixed(2)}%`,
    valorIndividual: currency(dadosPrevidenciarios.ValorIndividual),
    valorAdicional: currency(dadosPrevidenciarios.ValorAdicional),
    valorEventual: currency(dadosPrevidenciarios.ValorEventual),
    valorPortabilidadeAberta: currency(
      dadosPrevidenciarios.ValorPortabilidadeAberta
    ),
    Regressivo: {
      valorLiberacaoIndividual:
        (infosData.result.ValorIndividual *
          (100 - infosData.result.AliquotaIndividualRegressiva)) /
        100,
      valorLiberacaoAdicional:
        (infosData.result.ValorAdicional *
          (100 - infosData.result.AliquotaAdicionalRegressiva)) /
        100,
      valorLiberacaoEventual:
        (infosData.result.ValorEventual *
          (100 - infosData.result.AliquotaEventualRegressiva)) /
        100,
      valorLiberacaoPortabilidadeAberta:
        (infosData.result.ValorPortabilidadeAberta *
          (100 - infosData.result.AliquotaPortabilidadeAbertaRegressiva)) /
        100,
      valorLiberacaoTotal: Math.max(
        infosData.result.ValorTotalResgate -
          infosData.result.descontoEmprestimoRegressivo.descontoTotal -
          (infosData.result.ValorTotalResgate *
            infosData.result.AliquotaValorTotalRegressivo) /
            100,
        0
      ),
      contaIndividual: [
        {
          label: 'Percentual solicitado',
          value: `${infosData.params.contaIndividual}%`,
        },
        {
          label: 'Previsto para liberação',
          value: currency(infosData.result.ValorIndividual),
        },
        {
          label: 'Aliquota imposto regressivo',
          value: `${infosData.result.AliquotaIndividualRegressiva}%`,
        },
        {
          label: 'Desconto imposto de renda',
          value: currency(
            -(
              infosData.result.ValorIndividual *
              (infosData.result.AliquotaIndividualRegressiva / 100)
            )
          ),
        },
      ],
      contaAdicional: [
        {
          label: 'Percentual solicitado',
          value: `${infosData.params.contaAdicional}%`,
        },
        {
          label: 'Previsto para liberação',
          value: currency(infosData.result.ValorAdicional),
        },
        {
          label: 'Aliquota imposto regressivo',
          value: `${infosData.result.AliquotaAdicionalRegressiva}%`,
        },
        {
          label: 'Desconto imposto de renda',
          value: currency(
            -(
              infosData.result.ValorAdicional *
              (infosData.result.AliquotaAdicionalRegressiva / 100)
            )
          ),
        },
      ],
      contaEventual: [
        {
          label: 'Percentual solicitado',
          value: `${infosData.params.contaEventual}%`,
        },
        {
          label: 'Previsto para liberação',
          value: currency(infosData.result.ValorEventual),
        },
        {
          label: 'Aliquota imposto regressivo',
          value: `${infosData.result.AliquotaEventualRegressiva}%`,
        },
        {
          label: 'Desconto imposto de renda',
          value: currency(
            -(
              infosData.result.ValorEventual *
              (infosData.result.AliquotaEventualRegressiva / 100)
            )
          ),
        },
      ],
      contaPortabilidadeAberta: [
        {
          label: 'Percentual solicitado',
          value: `${infosData.params.contaPortabilidadeAberta}%`,
        },
        {
          label: 'Previsto para liberação',
          value: currency(infosData.result.ValorPortabilidadeAberta),
        },
        {
          label: 'Aliquota imposto regressivo',
          value: `${infosData.result.AliquotaPortabilidadeAbertaRegressiva}%`,
        },
        {
          label: 'Desconto imposto de renda',
          value: currency(
            -(
              infosData.result.ValorPortabilidadeAberta *
              (infosData.result.AliquotaPortabilidadeAbertaRegressiva / 100)
            )
          ),
        },
      ],
      detalhamento: [
        {
          label: 'Valor solicitado',
          value: currency(infosData.result.ValorTotalResgate),
        },
        {
          label: 'Aliquota imposto regressivo',
          value: `${infosData.result.AliquotaValorTotalRegressivo}%`,
        },
        {
          label: 'Desconto imposto de renda',
          value: currency(
            -(
              infosData.result.ValorTotalResgate *
              (infosData.result.AliquotaValorTotalRegressivo / 100)
            )
          ),
        },
        {
          label: 'Desconto empréstimo',
          value: currency(
            -infosData.result.descontoEmprestimoRegressivo.descontoTotal
          ),
          details: [
            {
              label: 'Valor vencido',
              value: currency(
                -infosData.result.descontoEmprestimoRegressivo.saldoVencido || 0
              ),
            },
            {
              label: 'Proporção do saldo a vencer',
              value: currency(
                -infosData.result.descontoEmprestimoRegressivo.saldoVencer
              ),
            },
          ],
        },
      ],
    },
    Progressivo: {
      valorLiberacaoIndividual:
        (infosData.result.ValorIndividual * (100 - 15)) / 100,
      valorLiberacaoAdicional:
        (infosData.result.ValorAdicional * (100 - 15)) / 100,
      valorLiberacaoEventual:
        (infosData.result.ValorEventual * (100 - 15)) / 100,
      valorLiberacaoPortabilidadeAberta:
        (infosData.result.ValorPortabilidadeAberta * (100 - 15)) / 100,
      valorLiberacaoTotal: Math.max(
        infosData.result.ValorTotalResgate -
          infosData.result.descontoEmprestimoProgressivo.descontoTotal -
          infosData.result.ValorTotalResgate * (15 / 100),
        0
      ),
      contaIndividual: [
        {
          label: 'Percentual solicitado',
          value: `${infosData.params.contaIndividual}%`,
        },
        {
          label: 'Previsto para liberação',
          value: currency(infosData.result.ValorIndividual),
        },
        {
          label: 'Aliquota imposto progressivo',
          value: `${15}%`,
        },
        {
          label: 'Desconto imposto de renda',
          value: currency(-(infosData.result.ValorIndividual * (15 / 100))),
        },
      ],
      contaAdicional: [
        {
          label: 'Percentual solicitado',
          value: `${infosData.params.contaAdicional}%`,
        },
        {
          label: 'Previsto para liberação',
          value: currency(infosData.result.ValorAdicional),
        },
        {
          label: 'Aliquota imposto progressivo',
          value: `${15}%`,
        },
        {
          label: 'Desconto imposto de renda',
          value: currency(-(infosData.result.ValorAdicional * (15 / 100))),
        },
      ],
      contaEventual: [
        {
          label: 'Percentual solicitado',
          value: `${infosData.params.contaEventual}%`,
        },
        {
          label: 'Previsto para liberação',
          value: currency(infosData.result.ValorEventual),
        },
        {
          label: 'Aliquota imposto progressivo',
          value: `${15}%`,
        },
        {
          label: 'Desconto imposto de renda',
          value: currency(-(infosData.result.ValorEventual * (15 / 100))),
        },
      ],
      contaPortabilidadeAberta: [
        {
          label: 'Percentual solicitado',
          value: `${infosData.params.contaPortabilidadeAberta}%`,
        },
        {
          label: 'Previsto para liberação',
          value: currency(infosData.result.ValorPortabilidadeAberta),
        },
        {
          label: 'Aliquota imposto progressivo',
          value: `${15}%`,
        },
        {
          label: 'Desconto imposto de renda',
          value: currency(
            -(infosData.result.ValorPortabilidadeAberta * (15 / 100))
          ),
        },
      ],
      detalhamento: [
        {
          label: 'Valor solicitado',
          value: currency(infosData.result.ValorTotalResgate),
        },
        {
          label: 'Aliquota imposto progressivo',
          value: `${15}%`,
        },
        {
          label: 'Desconto imposto de renda',
          value: currency(-(infosData.result.ValorTotalResgate * (15 / 100))),
        },
        {
          label: 'Desconto empréstimo',
          value: currency(
            -infosData.result.descontoEmprestimoProgressivo.descontoTotal
          ),
          details: [
            {
              label: 'Valor vencido',
              value: currency(
                -infosData.result.descontoEmprestimoProgressivo.saldoVencido ||
                  0
              ),
            },
            {
              label: 'Proporção do saldo a vencer',
              value: currency(
                -infosData.result.descontoEmprestimoProgressivo.saldoVencer
              ),
            },
          ],
        },
      ],
    },
  };
};

export const gerarComprovamenteResgateParcialPDF = (params) => {
  const service = new ResgateParcialService();
  service
    .GerarComprovanteResgateParcialPDF({
      ...params.registroResgate,
      matricula: params.registroResgate.Matricula,
      nome: params.nome,
      plano: params.plano,
      token: params.token,
    })
    .then((base64) => {
      const link = document.createElement('a');
      link.href = `data:application/pdf;base64,${base64}`;
      link.download = `Comprovante de resgate parcial - ${params.registroResgate.Matricula}.PDF`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
};

export const gerarMemoriaCalculoResgateParcialPDF = (
  matricula,
  anoMes,
  token
) => {
  const service = new ResgateParcialService();
  service
    .GerarMemoriaCalculoResgateParcialPDF({
      matricula,
      anoMes,
      token,
    })
    .then((res) => {
      const blob = new Blob([res], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `Memória de cálculo participante - ${matricula}.PDF`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
};

export const gerarDetalhamentoResgateParcialPDF = (
  dadosPessoais,
  registroParams,
  dadosEmprestimo,
  dadosPrevidenciarios
) => {
  const service = new ResgateParcialService();

  service
    .ObterDadosPrevidenciariosResgate(
      dadosPessoais.matricula,
      dadosPessoais.plano,
      registroParams.contaIndividual,
      registroParams.contaAdicional,
      registroParams.contaEventual,
      registroParams.contaPortabilidadeAberta
    )
    .then((result) => {
      const aliquotaIndividual =
        registroParams.regimeTributacao === 'REGRESSIVO'
          ? result.AliquotaIndividualRegressiva
          : 15;
      const aliquotaAdicional =
        registroParams.regimeTributacao === 'REGRESSIVO'
          ? result.AliquotaAdicionalRegressiva
          : 15;
      const aliquotaEventual =
        registroParams.regimeTributacao === 'REGRESSIVO'
          ? result.AliquotaEventualRegressiva
          : 15;
      const aliquotaPortabilidadeAberta =
        registroParams.regimeTributacao === 'REGRESSIVO'
          ? result.AliquotaPortabilidadeAbertaRegressiva
          : 15;
      const aliquotaTotal =
        registroParams.regimeTributacao === 'REGRESSIVO'
          ? result.AliquotaValorTotalRegressivo
          : 15;

      const percentualRetirado =
        (result.ValorTotalResgate / result.ValorIntegral) * 100;

      const valorTotalSemIR =
        result.ValorTotalResgate -
        (result.ValorTotalResgate * aliquotaTotal) / 100;

      const descontoTotalEmprestimo = Math.min(
        valorTotalSemIR,
        dadosEmprestimo.SaldoVencido +
          dadosEmprestimo.SaldoVencer * (percentualRetirado / 100) || 0
      );
      const saldoVencido = Math.min(
        valorTotalSemIR,
        dadosEmprestimo.SaldoVencido
      );

      const saldoVencer = Math.min(
        valorTotalSemIR - saldoVencido,
        dadosEmprestimo.SaldoVencer * (percentualRetirado / 100)
      );

      service
        .GerarDetalhamentoResgateParcialPDF({
          matricula: dadosPessoais.matricula,
          nome: dadosPessoais.nome,
          token: dadosPessoais.token,
          dtGeracao: format(new Date(), "dd/MM/yyyy 'às' HH:mm"),
          dtReferenciaEmprestimo: format(
            new Date(dadosEmprestimo.DataReferencia),
            'MM/yyyy'
          ),
          /// ///////////////////////////////////
          AliquotaIndividual: aliquotaIndividual,
          AliquotaAdicional: aliquotaAdicional,
          AliquotaEventual: aliquotaEventual,
          AliquotaPortabilidadeAberta: aliquotaPortabilidadeAberta,
          AliquotaValorTotal: aliquotaTotal,
          /// ///////////////////////////////////
          ValorIntegral: result.ValorIntegral,
          ValorIndividual: result.ValorIndividual,
          ValorAdicional: result.ValorAdicional,
          ValorEventual: result.ValorEventual,
          ValorPortabilidadeAberta: result.ValorPortabilidadeAberta,
          valorTotalSemDescontos: currency(result.ValorTotalResgate),
          /// ///////////////////////////////////
          RegimeTributacao: registroParams.regimeTributacao,
          percentualIndividual: Number(registroParams.contaIndividual),
          percentualAdicional: Number(registroParams.contaAdicional),
          percentualPortabilidadeAberta: Number(
            registroParams.contaPortabilidadeAberta
          ),
          percentualEventual: Number(registroParams.contaEventual),
          /// ///////////////////////////////////
          descontoEmprestimoVencer: saldoVencer || 0,
          descontoEmprestimoVencido: saldoVencido || 0,
          descontoEmprestimoTotal: descontoTotalEmprestimo,
          /// ///////////////////////////////////
          ValoresConta: {
            ValorIndividual: currency(dadosPrevidenciarios.ValorIndividual),
            ValorAdicional: currency(dadosPrevidenciarios.ValorAdicional),
            ValorEventual: currency(dadosPrevidenciarios.ValorEventual),
            ValorPortabilidadeAberta: currency(
              dadosPrevidenciarios.ValorPortabilidadeAberta
            ),
          },
          ValorTotalResgate: valorTotalSemIR - descontoTotalEmprestimo,
        })
        .then((base64) => {
          const link = document.createElement('a');
          link.href = `data:application/pdf;base64,${base64}`;
          link.download = `Detalhamento de resgate parcial - ${dadosPessoais.matricula}.PDF`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    });
};
